import {
  addNavMenuSection,
  registerCustomDetailComponent,
  registerFormInputComponent,
} from '@vendure/admin-ui/core';

import { HiddenInputComponent } from './hidden-input.component';
import { PriceCalculationComponent } from './price-calculation.component';

// TODO: make text translateable (i18n)
export default [
  registerCustomDetailComponent({
    locationId: 'product-variant-detail',
    component: PriceCalculationComponent,
  }),
  registerFormInputComponent('hidden-input', HiddenInputComponent),
  addNavMenuSection(
    {
      id: 'currency-conversion',
      label: 'Currency',
      items: [
        {
          id: 'currency-conversion-rate',
          label: 'Conversion Rates',
          routerLink: ['/extensions/currency-conversion'],
          icon: 'dollar',
        },
      ],
    },
    'settings',
  ),
];
